var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Radio } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colors, theme } from "../../../theme";
var useStyles = makeStyles({
    icon: {
        borderRadius: "50%",
        width: 20,
        height: 20,
        backgroundColor: colors.background.gray,
        backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.3),hsla(0,0%,100%,0.1))",
        "input:disabled ~ &": {
            boxShadow: "none",
            background: "#BDBDBD80"
        }
    },
    checkedIcon: {
        borderRadius: "50%",
        backgroundColor: theme.colors.primary,
        "input:disabled ~ &": {
            boxShadow: "none",
            opacity: 0.5
        },
        "&:before": {
            display: "block",
            width: 20,
            height: 20,
            backgroundImage: "radial-gradient(".concat(colors.white, ",").concat(colors.white, " 28%,transparent 32%)"),
            // eslint-disable-next-line
            content: '""'
        }
    }
});
// Inspired by blueprintjs
function AppRadio(props) {
    var classes = useStyles();
    return (_jsx(Radio, __assign({ disableRipple: true, color: "default", checkedIcon: _jsx("span", { className: classes.checkedIcon }), icon: _jsx("span", { className: classes.icon }) }, props)));
}
export { AppRadio };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwUmFkaW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy91aS9BcHBSYWRpby9BcHBSYWRpby50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLEtBQUssRUFBYyxNQUFNLGVBQWUsQ0FBQztBQUNsRCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBQ3pDLE9BQU8sRUFBRSxNQUFNLEVBQUUsS0FBSyxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFFL0MsSUFBTSxTQUFTLEdBQUcsVUFBVSxDQUFDO0lBQzNCLElBQUksRUFBRTtRQUNKLFlBQVksRUFBRSxLQUFLO1FBQ25CLEtBQUssRUFBRSxFQUFFO1FBQ1QsTUFBTSxFQUFFLEVBQUU7UUFDVixlQUFlLEVBQUUsTUFBTSxDQUFDLFVBQVUsQ0FBQyxJQUFJO1FBQ3ZDLGVBQWUsRUFBRSxnRUFBZ0U7UUFDakYsb0JBQW9CLEVBQUU7WUFDcEIsU0FBUyxFQUFFLE1BQU07WUFDakIsVUFBVSxFQUFFLFdBQVc7U0FDeEI7S0FDRjtJQUNELFdBQVcsRUFBRTtRQUNYLFlBQVksRUFBRSxLQUFLO1FBQ25CLGVBQWUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU87UUFDckMsb0JBQW9CLEVBQUU7WUFDcEIsU0FBUyxFQUFFLE1BQU07WUFDakIsT0FBTyxFQUFFLEdBQUc7U0FDYjtRQUNELFVBQVUsRUFBRTtZQUNWLE9BQU8sRUFBRSxPQUFPO1lBQ2hCLEtBQUssRUFBRSxFQUFFO1lBQ1QsTUFBTSxFQUFFLEVBQUU7WUFDVixlQUFlLEVBQUUsMEJBQW1CLE1BQU0sQ0FBQyxLQUFLLGNBQUksTUFBTSxDQUFDLEtBQUssMEJBQXVCO1lBQ3ZGLDJCQUEyQjtZQUMzQixPQUFPLEVBQUUsSUFBSTtTQUNkO0tBQ0Y7Q0FDRixDQUFDLENBQUM7QUFFSCwwQkFBMEI7QUFDMUIsU0FBUyxRQUFRLENBQUMsS0FBaUI7SUFDakMsSUFBTSxPQUFPLEdBQUcsU0FBUyxFQUFFLENBQUM7SUFFNUIsT0FBTyxDQUNMLEtBQUMsS0FBSyxhQUNKLGFBQWEsUUFDYixLQUFLLEVBQUMsU0FBUyxFQUNmLFdBQVcsRUFBRSxlQUFNLFNBQVMsRUFBRSxPQUFPLENBQUMsV0FBVyxHQUFJLEVBQ3JELElBQUksRUFBRSxlQUFNLFNBQVMsRUFBRSxPQUFPLENBQUMsSUFBSSxHQUFJLElBQ25DLEtBQUssRUFDVCxDQUNILENBQUM7QUFDSixDQUFDO0FBRUQsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDIn0=